import { render, staticRenderFns } from "./PodcastCreateTranslation.vue?vue&type=template&id=eabcc836&"
import script from "./PodcastCreateTranslation.vue?vue&type=script&lang=js&"
export * from "./PodcastCreateTranslation.vue?vue&type=script&lang=js&"
import style0 from "./PodcastCreateTranslation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports